/** Copy for signed-in pages that are linked from the app but not built yet. */
export const placeholderCopy = {
  body: 'This page is coming soon.',
  /** Pages linked from somewhere other than the navigation (whose labels title their own placeholders). */
  titles: {
    newPatient: 'New patient',
    patient: 'Patient',
    clinic: 'Clinic',
  },
} as const;
